import type { FilterKeys } from "@dresscode-frontend/utility-types";
import type { ColumnDef } from "@tanstack/react-table";

import { DataTableColumnHeader } from "@/components/DataTable/Columns/DataTableColumnHeader";
import type { HelperOptions } from "@/components/DataTable/types";
import { LastActivityCell } from "@/features/app-user/components/LastActivityCell";
import type {
  AppUserTableRow,
  MatchedUserRow,
  NoWorkerUserRow,
  ViolatedUserRow,
} from "@/features/app-user/types";

type LastActivityDateColumnOptions = HelperOptions & {
  accessorKey?: string;
  accessorFn?: (row: AppUserTableRow) => Date | null;
};

/** 連携したアプリからDressCodeが取得したAppUserの最終操作(主にログイン)日時を表示するカラムコンポーネント */
export function LastActivityDateColumn<
  TData extends MatchedUserRow | ViolatedUserRow | NoWorkerUserRow,
>(
  id: FilterKeys<TData, Date | null> & string,
  options: LastActivityDateColumnOptions = {},
): ColumnDef<TData> {
  const { minWidth = "200px", accessorKey, accessorFn } = options;

  return {
    id,
    ...(accessorKey ? { accessorKey } : {}),
    ...(accessorFn ? { accessorFn } : { accessorKey: id }),
    meta: { i18nKey: "lastActivity" as const, thStyle: { minWidth } },
    header(props) {
      return <DataTableColumnHeader {...props} />;
    },
    cell: function Cell({ row }) {
      const rowData = row.original;
      const date = row.getValue<Date | null>(id);
      return <LastActivityCell date={date} isActive={rowData.isActive} />;
    },
  };
}
